import { Selection } from "@tiptap/pm/state";

import { nodeIsExpression } from "@/components/tiptap/tiptap-expression/utils";

import type { DocumentModel } from "@/models/DocumentModel";
import type { Editor } from "@tiptap/react";

export function focusFirstNodeAfterPos(pos: number, editor: Editor, doc: DocumentModel): void {
  const selection = Selection.findFrom(editor.state.doc.resolve(pos), 1);
  if (selection) {
    const firstNodeAfterTitle = editor.state.doc.nodeAt(selection.anchor);
    if (firstNodeAfterTitle && nodeIsExpression(firstNodeAfterTitle)) {
      editor.commands.setNodeSelection(pos);

      const wrapperNodeId = firstNodeAfterTitle.attrs.nodeId;
      const wrapperNode = doc.textNode.wrapperNodes.find((n) => n.id === wrapperNodeId);
      if (wrapperNode && wrapperNode.inlineNode) {
        doc.cursor.moveTo(wrapperNode.inlineNode, 0);
      }
    } else if (firstNodeAfterTitle?.type.name === "image") {
      editor
        .chain()
        .setNodeSelection(selection.anchor)
        .focus(undefined, { scrollIntoView: false })
        .run();
    } else {
      editor.chain().focus(selection.anchor, { scrollIntoView: false }).run();
    }
  }
}

export function focusFirstNodeAfterTitle(editor: Editor, doc: DocumentModel): void {
  if (!doc.autoFocus) {
    return;
  }

  const documentTitleSize =
    editor.state.doc.firstChild?.type.name === "documentTitle"
      ? editor.state.doc.firstChild.nodeSize
      : 0;

  focusFirstNodeAfterPos(documentTitleSize, editor, doc);
}
